import ResourceList from "../../../components/ResourceList";
import {ResourcePanel, ResourcePanelNote, ResourcePanelTitle, openInNewTab} from "../../../components/ResourcePanel";
import {reachUrls} from "../../../layout/menu-items";
import {TemplateAssetReference, TemplateSnippetReference} from "../../../apis/requests/resources/types";

type Props = {
  snippets?: TemplateSnippetReference[];
  assets?: TemplateAssetReference[];
  unknownSnippets?: string[];
};

const TemplateResourcesPanel = ({snippets, assets, unknownSnippets}: Props) => {
  if (!snippets || !assets) return null;

  const unknown = unknownSnippets ?? [];

  return (
    <ResourcePanel>
      {unknown.length > 0 && (
        <>
          <ResourcePanelTitle>Unknown snippets</ResourcePanelTitle>
          <ResourcePanelNote>
            {unknown.length === 1 ? "This reference does not" : "These references do not"} match any snippet - they
            will render as nothing when the message is sent.
          </ResourcePanelNote>
          <ResourceList items={unknown.map((key) => ({id: key, label: key, variant: "error"}))} />
        </>
      )}

      <ResourcePanelTitle spaced={unknown.length > 0}>Uses snippets</ResourcePanelTitle>
      {snippets.length === 0 ? (
        <ResourcePanelNote>This template does not use any snippets.</ResourcePanelNote>
      ) : (
        <ResourceList
          items={snippets.map((snippet) => ({
            id: snippet.key,
            label: snippet.name,
            onClick: () => openInNewTab(`${reachUrls.snippets}/${snippet.snippet_id}`),
          }))}
        />
      )}

      <ResourcePanelTitle spaced>Uses images</ResourcePanelTitle>
      {assets.length === 0 ? (
        <ResourcePanelNote>This template does not use any images.</ResourcePanelNote>
      ) : (
        <ResourceList
          items={assets.map((asset) => ({
            id: asset.url,
            label: asset.name ?? "Not managed in Reach",
            imageUrl: asset.url,
            tooltip: [
              asset.name ?? "Hosted outside Reach - not an uploaded asset",
              asset.via_snippet ? `comes from the "${asset.via_snippet}" snippet` : null,
            ]
              .filter(Boolean)
              .join(" - "),
            onClick: asset.asset_id
              ? () => openInNewTab(`${reachUrls.assets}?search=${encodeURIComponent(asset.url)}`)
              : () => openInNewTab(asset.url),
          }))}
        />
      )}
    </ResourcePanel>
  );
};

export default TemplateResourcesPanel;
